import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import AppBarComponent from "../../common/components/AppBarComponent";
import MuiPhoneInput from "material-ui-phone-number";

const UserForm = (props) => {
  let fieldError = (field) => {
    var f = props.isFormFieldInvalid(field);
    if (f) {
      return f.error;
    } else {
      return false;
    }
  };

  let fieldHelperText = (field) => {
    var f = props.isFormFieldInvalid(field);
    if (f) {
      return f.helperText;
    } else {
      return "";
    }
  };
  return (
    <div className="row main_popup">
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        TransitionComponent={props.Transition}
        className="popup-module"
      >
        <AppBarComponent
          icon={"fa fa-user"}
          title={props.userType}
          handleClose={props.handleClose}
        />

        <DialogContent className="dialogContent">
          <form className="dialogContent-form">
            <TextField
              required
              id="user-name"
              label="Full Name"
              style={{ marginBottom: 8 }}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.editUserForm
                  ? props.existingUser.name
                  : props.newUser.name
              }
              onChange={props.onUserNameChange}
              // onBlur={props.isFormValid}
              error={fieldError("name")}
              helperText={fieldHelperText("name")}
            />
            <TextField
              required
              id="user-username"
              label="Username"
              type="text"
              style={{ marginBottom: 8 }}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.editUserForm
                  ? props.existingUser.username
                  : props.newUser.username
              }
              inputProps={{
                form: {
                  autocomplete: "off",
                },
              }}
              disabled={props.editUserForm}
              onChange={props.onUserUserNameChange}
              onBlur={props.onUserValid}
              error={fieldError("username")}
              helperText={fieldHelperText("username")}
            />

            {!props.editUserForm ? (
              <TextField
                required
                id="user-password"
                label="Password"
                onBlur={props.onUserPasswordChangeError}
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                type={props.type === "password" ? "text" : "password"}
                value={
                  props.editUserForm
                    ? props.existingUser.password
                    : props.newUser.password
                }
                autoComplete="new-password"
                onChange={props.onUserPasswordChange}
                InputProps={{
                  form: {
                    autocomplete: "off",
                  },
                  endAdornment: (
                    <InputAdornment position="end" className="passwordicon">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={props.handleClickShowPassword}
                        disabled={props.editUserForm}
                      >
                        {props.type === "password" ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={fieldError("password")}
                helperText={fieldHelperText("password")}
                disabled={props.editUserForm}
              />
            ) : null}

            <MuiPhoneInput
              defaultCountry={"us"}
              disableDropdown
              required
              id="user-telephone"
              type="text"
              label="Contact No."
              style={{ marginBottom: 8 }}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.editUserForm
                  ? props.existingUser.telephone
                  : props.newUser.telephone
              }
              onChange={props.onUserTelephoneChange}
              onBlur={props.onPhoneValCheck}
              error={fieldError("telephone")}
              helperText={fieldHelperText("telephone")}
            />

            <TextField
              required
              id="user-email"
              label="Email Id"
              type="text"
              style={{ marginBottom: 8 }}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.editUserForm
                  ? props.existingUser.email
                  : props.newUser.email
              }
              onChange={props.onUserEmailIdChange}
              onBlur={props.onEmailValCheck}
              error={fieldError("email")}
              helperText={fieldHelperText("email")}
            />

            {props.showOrganizationSelect && (
              <FormControl
                style={{ marginBottom: 8, minWidth: 120 }}
                error={fieldError("organization")}
              >
                <InputLabel id="organization-select-label">
                  Organization
                </InputLabel>
                <Select
                  labelId="organization-select-label"
                  id="organization-select"
                  value={
                    props.editUserForm
                      ? props.existingUser.organization || ""
                      : props.newUser.organization || ""
                  }
                  onChange={props.onUserOrganizationChange}
                  error={fieldError("organization")}
                  helperText={fieldHelperText("organization")}
                >
                  {props.organizations.length > 0 &&
                    props.organizations.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {`${option.name}`}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}

            <TextField
              required
              id="user-address_1"
              label="Address"
              onChange={props.onUserAddress1Change}
              multiline
              rows="4"
              style={{ marginBottom: 8 }}
              margin="normal"
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.editUserForm
                  ? props.existingUser.address_1
                  : props.newUser.address_1
              }
              onBlur={props.onAddressCheck}
              error={fieldError("address_1")}
              helperText={fieldHelperText("address_1")}
            />
            {props.role === "owner" || props.userType === "Operator" ? (
              <div className="form-button-container">
                <a
                  variant="outlined"
                  className="form-cancel-button btn"
                  onClick={props.handleClose}
                  style={{ flex: 1 }}
                >
                  Cancel
                </a>
                <a
                  variant="outlined"
                  className="form-submit-button btn btn-default"
                  onClick={
                    props.editUserForm
                      ? props.editExistingUser
                      : props.addNewUser
                  }
                  style={{ flex: 1 }}
                >
                  {props.editUserForm
                    ? "Edit " + props.userType
                    : "Add " + props.userType}
                </a>
              </div>
            ) : null}
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default UserForm;
